import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IPackageItemListItem {
  id: string | number;
  packageId: number;
  itemNo: number;
  itemDetails: string;
  itemName: string;
  itemAmount: number;
  partNumber: string;
  sdDocPenNumber: string;
  date: Date;
}

export class IPackageItemListResponse extends IPagination {
  @Type(() => IPackageItemListItem)
  results: IPackageItemListItem[];
}

export class IPackageItemQueryDto extends IQueryPaginationDto {
  package_id?: string | number;
}
